import { create } from 'zustand';

interface SignerState {
  isSigning: boolean;
  txCost: string;
  functionName: string;
  approveSigner: (txCost: string, functionName: string) => Promise<boolean>;
  resolvePromise: ((value: boolean) => void) | null;
  handleSign: () => void;
  handleReject: () => void;
}

export const useSignerStore = create<SignerState>((set, get) => ({
  isSigning: false,
  resolvePromise: null,
  txCost: '0',
  functionName: '',

  approveSigner: (txCost: string, functionName: string) => {
    return new Promise<boolean>(resolve => {
      set({
        resolvePromise: resolve,
        isSigning: true,
        txCost: txCost,
        functionName: functionName,
      });
    });
  },

  handleSign: () => {
    const { resolvePromise } = get();
    if (resolvePromise) {
      resolvePromise(true);
    }
    set({ isSigning: false });
  },

  handleReject: () => {
    const { resolvePromise } = get();
    if (resolvePromise) {
      resolvePromise(false);
    }
    set({ isSigning: false });
  },
}));
